import { render } from "./CategoryElevenDialog.vue?vue&type=template&id=2f02157b&scoped=true"
import script from "./CategoryElevenDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryElevenDialog.vue?vue&type=script&lang=ts"

import "./CategoryElevenDialog.vue?vue&type=style&index=0&id=2f02157b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f02157b"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
